import Model, { attr, belongsTo } from '@warp-drive/legacy/model';

import {
  buildValidations,
  validator,
} from 'umg-ember-backend/utils/validations';

const Validations = buildValidations({
  name: validator('presence', true),
  country: [validator('belongs-to'), validator('presence', true)],
  partnerType: [validator('belongs-to'), validator('presence', true)],
});

export default class LivePartnerModel extends Model.extend(Validations) {
  @attr('string') city;
  @attr('string') cityEn;
  @attr('boolean') dgg;
  @attr('string') name;
  @attr('string') street;
  @attr('string') zipcode;

  // Meta fields
  @attr cmsCreated;
  @attr cmsDeleted;
  @attr cmsLocktime;
  @attr cmsModified;
  @attr() cmsHistory;
  @belongsTo('user', { async: true, inverse: null }) cmsOwnerId;
  @belongsTo('user', { async: true, inverse: null }) cmsCreatorId;
  @belongsTo('user', { async: true, inverse: null }) cmsLockerId;
  @belongsTo('user', { async: true, inverse: null }) cmsModifierId;

  // Relations
  @belongsTo('asset', { async: true, inverse: null }) logo;
  @belongsTo('link', { async: true, inverse: null }) link;
  @belongsTo('category', { async: true, inverse: null }) partnerType;
  @belongsTo('category', { async: true, inverse: null }) country;

  // Getter and setter
  get displayHeadline() {
    return this.name;
  }

  get displayLabel() {
    return this.name;
  }
}
